<template>
  <div>
    <portlet
      :icon="'fas fa-users portlet-icon'"
      :title="$t('engagement.employeeengagementoverview')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20"
    >
      <template slot="portletBody">
        <div class="container-fluid h-100 overview_container">
          <!-- {{allUsers}} -->
          <!-- {{this.getMe}} -->
                    <!-- hier zo employees i.p.v allUsers moeten staan, maar in DEV firebase zijn er alleen maar admins -->
          <EmployeeOverviewRow
            v-for="user in allUsers"
            :key="user.index"
            :user="user"
          />
        </div>
      </template>
      
    </portlet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EmployeeOverviewRow from "@/components/engagement/EmployeeOverviewRow.vue";

export default {
  name: "EngagamentOverview",
  mixins: [],
  components: {
    EmployeeOverviewRow,
  },
  data() {
    return {
      allUsers: [],
      employees: [],
      searchUid: "",
      searchActivity: "",
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("userData", ["getMyDepartments"]),
    ...mapGetters("users", ["getMe", "getClaims"]),
  },
  mounted() {
  },
  methods: {
    async filterEmployees(){

    }
  },
  async created() {
    this.$store.commit("setLoading", true);
    await this.$FUNCTIONS
      .Users("getAllUsers")
      .then((res) => {
        this.allUsers = res.data;
        this.$store.commit("setLoading", false);
      })
      .catch((e) => {
        console.log(1, e);
        this.$store.commit("setLoading", false);
      });

    this.employees = this.allUsers.map((user) => {
      if (user.customClaims.admin || user.customClaims.teamlead) {
        if(user.customClaims.admin && user.customClaims.admin === true){
          return 
        }else if(user.customClaims.teamlead && user.customClaims.teamlead === true){
          return 
        }
      } else {
        return user
      }
    })

    this.employees = this.employees.filter((user) => {
      return user !== undefined;
    })
    console.log(this.employees)
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewBar.scss";
</style>